import { Button } from 'src/utilities/UILibrary/UI/Button/Button';
import {
  ModalContainer,
  SectionInfo,
  DetailData,
  GeneralDetail,
  Success
} from './investConfirm.styles';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useState, useEffect } from 'react';
import { fetchPersonalInformation, createInvestment } from 'src/store/Profile/profile.slice';
import { useDispatch, useSelector } from 'react-redux';
import { InputField } from 'src/utilities/UILibrary/Forms/InputField/InputField';
import getCurrentDate from 'src/functions/getCurrentDate';
import { environment, url } from 'src/environments';
import createNumber from 'src/functions/createNumber';

export default function InvestConfirmation({
  showModalAdviceValidation,
  closeModal,
  displayInvestment,
  interesInversionistaPesos,
  item,
  amount,
  interestPercentage
}) {
  const [showInput, setShowInput] = useState(false);
  const [messageId, setMessageId] = useState();
  const [otp, setOtp] = useState('');
  const [successText, setSuccessText] = useState(false);
  const bankInformation = useSelector((state) => state.profile);
  const personalInformation = useSelector((state) => state.profile.personalInformation);

  const user = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();
  //Función para obtener fecha de pago para el body en pagaré
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + item?.plazoCredito);
  const dateToPay = currentDate.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  useEffect(() => {
    if (user.id) {
      dispatch(fetchPersonalInformation(user.id));
    }
  }, [user.id, dispatch]);
  const company = personalInformation?.data?.getInvestor?.companyInformation;
  const personal = personalInformation?.data?.getInvestor?.personalInformation;
  const account = personalInformation?.data?.getInvestor?.STP;
  const legalRep = item?.applicant?.personalInformation?.fullName;
  const obligadoSolidario = item?.applicant?.companyInformation?.obligadoSolidario;
  const campaignId = item?.id;

  const handleSendEmail = () => {
    const input = {
      id: user.id,
      typeOfUser: 'investor',
      typeMessage: 'investMoney',
      email: user.email,
      timestamp: Date.now()
    };
    axios
      .post(`${url}/${environment}/admin/send-otp-to-email`, input)
      .then((response) => {
        const parsedBody = JSON.parse(response.data.body);
        setMessageId(parsedBody.messageId);
        setShowInput(true);
      })
      .catch((error) => {
        console.error(error);
      });
    setShowInput(true);
  };

  const handleOtpSubmit = async () => {
    const input = {
      id: user.id,
      messageId: messageId,
      code: otp,
      timestamp: Date.now(),
      typeOfUser: 'investor'
    };
    try {
      const validationCode = await axios.post(
        `${url}/${environment}/admin/email/validate-otp`,
        input
      );
      const parsedBody = JSON.parse(validationCode.data.body);
      if (!parsedBody.isVerified) {
        alert('Validación de código fallida');
        return;
      }
      const investment = {
        investorId: user.id,
        campaignId: item.id,
        compromisoInversion: displayInvestment,
        interesInversionistaPorcentaje: item.tasaCreditoPorcentaje,
        interesInversionistaPesos: interesInversionistaPesos,
        retencionImpuestoInversionistaPorcentaje: 0.02,
        retencionImpuestoInversionistaPesos: interesInversionistaPesos,
        porcentajeGananciaInteres: interestPercentage,
        createdAt: getCurrentDate(),
        updatedAt: getCurrentDate()
      };
      dispatch(createInvestment(investment));
      const resources = {
        clientId: user.id,
        amount: parseInt(displayInvestment),
        type: 'compromisoinversion',
        campaignId: campaignId
      };
      const config = {
        method: 'put',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_STPURL_FINSPHERA}/update-investor-balances-in-STP`,
        headers: {
          apiKey: `${process.env.REACT_APP_APIKEY_STP}`,
          'Content-Type': 'application/json'
        },
        data: resources
      };
      try {
        const response = await axios(config);
        return response;
      } catch (error) {
        console.error(error);
      }

      if (item.montoSolicitado === item.collectedAmount) {
        const promisory = {
          id: user.id,
          idPromissory: campaignId,
          companyName: company.companyName,
          amount: displayInvestment,
          dateToPay: dateToPay,
          annualInterestRate: 0.18,
          taxToInterest: 0.16,
          legalRepresentative: legalRep,
          guarantor: obligadoSolidario
        };
        const updateCampaign = {
          type: 'update_campaign_successful',
          input: {
            campaignId: campaignId
          }
        };
        const sendEmailInvestor = {
          typeMessage: 'investors_campaign_successful',
          campaignId: campaignId,
          typeOfUser: 'investor'
        };
        const sendEmail = {
          typeMessage: 'applicant_campaign_successful',
          campaignId: campaignId,
          typeOfUser: 'applicant'
        };
        const [sendMailResponse, sendMailInvestorResponse] = await Promise.all([
          axios.post(`${process.env.REACT_APP_URL_FINSPHERA}/admin/campaign/send-email`, sendEmail),
          axios.post(
            `${process.env.REACT_APP_URL_FINSPHERA}/admin/campaign/send-email`,
            sendEmailInvestor
          )
        ]);
        const update = axios.post(
          `${process.env.REACT_APP_URL_FINSPHERA}/prod/admin/dynamo/update`,
          updateCampaign
        );
        const sendPromisoryNote = axios.post(
          `${process.env.REACT_APP_URL_FINSPHERA}/prod/mifiel/documents/create-promissory-note`,
          promisory
        );
      }
      setSuccessText(true);
    } catch (error) {
      console.error(error);
    }
  };

  function formatCurrency(amount) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount);
  }
  const formatedAmount = formatCurrency(amount);
  const retencionImpuestoInversionistaPesos = interesInversionistaPesos * 0.02;
  return (
    <ModalContainer showModalAdviceValidation={showModalAdviceValidation}>
      {!successText ? (
        <SectionInfo>
          <figure onClick={closeModal}>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_close.png`}
              alt="icono para cerrar la ventana"
            />
          </figure>
          <h1>¡Estás a punto de invertir en esta campaña!</h1>
          <GeneralDetail>
            <h2>Detalles de tu inversión: </h2>
            <div>
              <h3>Monto en tu cuenta de Finsphera: </h3>
              <p>{formatedAmount}</p>
            </div>
            <div>
              <h3>Monto a transferir: </h3>
              <p>{formatCurrency(displayInvestment)}</p>
            </div>
          </GeneralDetail>
          <DetailData>
            <div>
              <h3>Monto de Retención de (ISR)</h3>
              <p>{formatCurrency(retencionImpuestoInversionistaPesos)}</p>
            </div>
            <div>
              <h3>Interés en pesos</h3>
              <p>{formatCurrency(interesInversionistaPesos)}</p>
            </div>
            <div>
              <h3>Ganancia proyectada</h3>
              <p>
                {formatCurrency(interesInversionistaPesos + retencionImpuestoInversionistaPesos)}
              </p>
            </div>
            <h2>Información de la campaña: </h2>
            <div>
              <h3>Plazo estimado de retorno de la inversión: </h3>
              <p>{item?.plazoCredito}</p>
            </div>
            <div>
              <h3>Nombre de campaña: </h3>
              <p>{item?.nombreCampania}</p>
            </div>
            <div>
              <h3>Monto solicitado de la campaña: </h3>
              <p>{formatCurrency(item?.montoSolicitado)}</p>
            </div>
            <div>
              <h3>Nombre de la compañía: </h3>
              <p>{item?.applicant.companyInformation.companyName}</p>
            </div>
          </DetailData>
          {showInput ? (
            <div>
              <p>Ingresa el código que enviamos a tu correo:</p>
              <input
                // label="Ingresa el código que enviamos a tu correo:"
                type="text"
                value={otp}
                onChange={(e) => {
                  setOtp(e.target.value);
                }}
              />
              <Button size="small" onClick={handleOtpSubmit}>
                Confirmar código
              </Button>
            </div>
          ) : (
            <Button size="small" onClick={handleSendEmail}>
              Confirmar
            </Button>
          )}
        </SectionInfo>
      ) : (
        <Success>
          <figure>
            <img
              src={`${process.env.REACT_APP_BUCKET_FINSPHERA}/icon_modal_success.png`}
              alt="icono de correo electrónico"
            />
          </figure>
          <h2>¡Tu inversión se ha registrado de forma exitosa!</h2>
          <p>
            Puedes ver el avance de esta y otras campañas en las que inviertas en tu{' '}
            <Link to="/inversionista/dashboard/inversiones">Panel de inversiones</Link>
          </p>
          <Button onClick={closeModal}>Cerrar</Button>
        </Success>
      )}
    </ModalContainer>
  );
}
